import { render, staticRenderFns } from "./LineageReport.vue?vue&type=template&id=5c1e573a&scoped=true"
import script from "./LineageReport.vue?vue&type=script&lang=ts"
export * from "./LineageReport.vue?vue&type=script&lang=ts"
import style0 from "./LineageReport.vue?vue&type=style&index=0&id=5c1e573a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e573a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1e573a')) {
      api.createRecord('5c1e573a', component.options)
    } else {
      api.reload('5c1e573a', component.options)
    }
    module.hot.accept("./LineageReport.vue?vue&type=template&id=5c1e573a&scoped=true", function () {
      api.rerender('5c1e573a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/LineageReport.vue"
export default component.exports